import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Users, Truck, FileText, Calendar, Building2 } from 'lucide-react';

const TIPS = [
  { icon: Users, text: 'Invite users', to: '/user-management' },
  { icon: Truck, text: 'Add vehicles', to: '/vehicles' },
  { icon: FileText, text: 'Create service requests', to: '/service-requests' },
  { icon: Calendar, text: 'Schedule work', to: '/work-schedules' },
];

const MANAGER_TIP = { icon: Building2, text: 'Manage facilities', to: '/facility-management' };

const WelcomeModal = ({ onDismissed }) => {
  const { user, api } = useAuth();
  const [open, setOpen] = useState(true);
  const [dismissing, setDismissing] = useState(false);

  const isManagerOrAdmin = ['ADMIN', 'MANAGER'].includes(user?.role);
  const tips = isManagerOrAdmin ? [...TIPS, MANAGER_TIP] : TIPS;

  const handleDismiss = async () => {
    setDismissing(true);
    try {
      await api.post('/users/me/dismiss-welcome');
    } catch (e) {
      console.error('Failed to persist welcome dismissal:', e);
    }
    setOpen(false);
    onDismissed?.();
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md [&>button:last-child]:hidden"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        data-testid="welcome-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-xl" data-testid="welcome-modal-title">
            Welcome to Onsite Rail Solutions
          </DialogTitle>
          <DialogDescription className="text-[#5A5A5A]">
            Get started in a few quick steps:
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-3 py-2">
          {tips.map((tip, i) => {
            const Icon = tip.icon;
            return (
              <li key={tip.text} className="flex items-center gap-3 text-sm text-[#323033]">
                <div className="w-8 h-8 rounded-lg bg-[#005EF8]/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-4 h-4 text-[#005EF8]" />
                </div>
                <span>{tip.text}</span>
              </li>
            );
          })}
        </ul>

        <DialogFooter>
          <Button
            onClick={handleDismiss}
            disabled={dismissing}
            className="w-full bg-[#005EF8] hover:bg-[#0047C2] text-white"
            data-testid="welcome-modal-dismiss-btn"
          >
            Get started
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
